import apiClient from '../lib/api';

export interface ToSData {
  version: string;
  date?: string;
  content: string;
}

export interface ToSStatus {
  accepted_version: string | null;
  accepted_date: string | null;
  current_version: string;
  acceptance_required: boolean;
}

export const getLatestToS = async (): Promise<ToSData> => {
  const response = await apiClient.get('/api/terms/latest');
  return response.data;
};

export const getToSByVersion = async (version: string): Promise<ToSData> => {
  const response = await apiClient.get(`/api/terms/version/${version}`);
  return response.data;
};

export const acceptToS = async (businessId: number, version: string, token: string): Promise<{ success: boolean; message: string }> => {
  const response = await apiClient.post(
    '/api/terms/accept',
    { business_id: businessId, version },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const getToSStatus = async (businessId: number, token: string): Promise<ToSStatus> => {
  const response = await apiClient.get(`/api/terms/status/${businessId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
